import { Plus } from 'lucide-react';
import { Button } from '@components/ui/button/Button';
import { usePermissions } from '@shared/hooks/usePermissions';
import { useTranslation } from 'react-i18next';
import { useRef } from 'react';
import { ModalCenterRef } from '@shared/components/ui/ModalCenter';
import { InviteUserModal } from '../modals';

interface InviteUserButtonProps {
  /** Callback que se ejecuta cuando se hace click en el botón */
  onClick?: () => void;
  /** Callback que se ejecuta después de invitar exitosamente */
  onSuccess?: () => void;
}

/**
 * Componente para el botón de invitar usuario
 * Maneja los permisos de invitación
 */
export const InviteUserButton = ({ onClick, onSuccess }: InviteUserButtonProps) => {
  const { t } = useTranslation('usersModule');
  const { canAccess } = usePermissions();
  const modalRef = useRef<ModalCenterRef>(null);

  // Verificar si el usuario puede invitar usuarios
  // Requiere rol admin según la configuración del menú
  const canInvite = canAccess(['tenant', 'tenant_3pl', 'tenant_external'], []);

  // Si no tiene permisos, no mostrar el botón
  if (!canInvite) {
    return null;
  }

  const handleClick = () => {
    onClick?.();
    modalRef.current?.openModal();
  };

  const handleSuccess = () => {
    onSuccess?.();
  };

  return (
    <>
      <Button variant="primary" size="default" onClick={handleClick} data-testid="invite-user-button">
        <Plus className="h-4 w-4" aria-hidden />
        {t('buttons.invite')}
      </Button>
      <InviteUserModal ref={modalRef} onSuccess={handleSuccess} />
    </>
  );
};
